require('backboneAdapter');
import GenericModel from 'js/models/generic.model';
require('moment');

export default GenericModel.extend({
    urlRoot: '/CampaignCloud/Invoice',
    url: function () {
        return `${this.urlRoot}/first`;
    },
    idAttribute: 'invoiceDetailsId',
    defaults: {
        invoiceDetailsId: -1,
        addressOne: null,
        addressTwo: null,
        city: null,
        companyName: null,
        country: null,
        post_code: null,
        vatNumber: null

    }
});
